import script from "./RightSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightSidebar.vue?vue&type=script&setup=true&lang=js"

import "./RightSidebar.vue?vue&type=style&index=0&id=0fb9f155&scoped=true&lang=css"

import exportComponent from "/Users/aakash/Documents/projects/portfoilio-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb9f155"]])

export default __exports__